import { render, staticRenderFns } from "./PaymentPlanDetailPage.vue?vue&type=template&id=58605dcc&scoped=true&"
import script from "./PaymentPlanDetailPage.vue?vue&type=script&lang=ts&"
export * from "./PaymentPlanDetailPage.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentPlanDetailPage.vue?vue&type=style&index=0&id=58605dcc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58605dcc",
  null
  
)

export default component.exports